// File: src/components/Footer.jsx
import { useEffect, useState } from "react";
import "../../Styles/Footer.css";
import nexoraimg from "../../assests/elumiya.png";
import tabbyBadge from "../../assests/tabby-badge.svg";
import {
  FiClock,
  FiMapPin,
  FiPhone,
  FiMail,
  FiChevronRight,
} from "react-icons/fi";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faFacebook,
  faInstagram,
  faTwitter,
  faXTwitter,
  faCcVisa,
  faCcMastercard,
  faCcPaypal,
} from "@fortawesome/free-brands-svg-icons";
import { connect } from "react-redux";
import { getcategoryRequest } from "../../Containers/Product/Product-slice";
import { getViewportIsMobile } from "../../utils/browser";
function Footer({ getcategoryRequest }) {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    getcategoryRequest();
  }, [getcategoryRequest]);

  useEffect(() => {
    const update = () => setIsMobile(getViewportIsMobile());
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const about = [
    {
      Linkname: "Our Story",
      Link: "/story",
    },
    {
      Linkname: "Contact Us",
      Link: "/contact",
    },
    {
      Linkname: "Blogs",
      Link: "/blogs",
    },
  ];

  const policy = [
    { linkname: "Delivery Policy", link: "/faq/delivery" },
    { linkname: "Returns & Refunds", link: "/faq/returns" },
    { linkname: "Replacement Policy", link: "/faq/replacement" },
    { linkname: "Insurance & Warranty", link: "/faq/insurance" },
    { linkname: "Payment Gateway", link: "/faq/payment" },
    { linkname: "Terms of Use", link: "/faq/terms" },
    { linkname: "Privacy Policy", link: "/faq/privacy" },
    // { linkname: "Developer Instructions", link: "/faq/developer" },
    { linkname: "Legal Disclaimer", link: "/faq/legal" },
    { linkname: "FAQs", link: "/faq/Questions" },
  ];

  // Social media URLs - replace with your actual social media links
  const socialMediaLinks = {
    twitter: "https://x.com/ElumiaM73605/",
    linkedin: "https://linkedin.com/company/elumia-medstore/",
    facebook: "https://www.facebook.com/people/Elumia-Medstore/61587722259635/",
    instagram: "https://www.instagram.com/elumiamedstore/",
    youtube: "https://youtube.com/",
  };

  const paymentMethods = [
    { label: "Visa", image: "https://d28wu8o6itv89t.cloudfront.net/images/Visadebitcardpng-1599584312349.png", color: "white", type: "image" },
    {
      label: "Mastercard",
      image: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/MasterCard_Logo.svg/1280px-MasterCard_Logo.svg.png",
      color: "white",
      type: "image",
    },
    { label: "PayPal", image: "https://www.shutterstock.com/image-illustration/paypal-logo-on-transparent-background-260nw-2311643717.jpg", color: "white", type: "image" },

    // ✅ CDN Images
    {
      label: "Tabby",
      image: tabbyBadge,
      type: "image",
    },
    {
      label: "Tamara",
      image:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRRMPgJSHwiQvqev0zA95g6dEjuyrqRyDphAw&s",
      type: "image",
    },
  ];

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="site-footer__container">
        <div className="site-footer__col footer-contact-card">
          <img src={nexoraimg} alt="Elumia Med Store" className="footer-logo" />

          <div className="footer-info">
            <div className="footer-row">
              <FiClock className="footer-icon" />
              <span>Mon - Sun, 11:00 AM - 9:00 PM</span>
            </div>

            <div className="footer-row">
              <FiMapPin className="footer-icon" />
              <span>
                Warehouse No 10, Abdouli Complex Industrial area
                <br />
                First - Al qusais - United Arab Emirates
              </span>
            </div>

            <div className="footer-row">
              <FiPhone className="footer-icon" />
              <span>+971 50 257 6257</span>
            </div>

            <div className="footer-row">
              <FiMail className="footer-icon" />
              <span>info@elumiamedstore.com</span>
            </div>
          </div>

          {/* Social Media */}
          <div className="footer-social-icons">
            <a
              href={socialMediaLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
            >
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a
              href={socialMediaLinks.facebook}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FontAwesomeIcon icon={faFacebook} />
            </a>
            <a
              href={socialMediaLinks.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
            <a
              href={socialMediaLinks.twitter}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="X (Twitter)"
            >
              <FontAwesomeIcon icon={faXTwitter} />
            </a>
          </div>

          <div className="footer-payments">
            <span className="footer-payments__label">Accepted Payments</span>
            <div
              className="footer-payments__icons"
              aria-label="Payment methods"
            >
              {paymentMethods.map((method) => (
                <span key={method.label} className="footer-payments__icon">
                  {method.label === "PayPal" && isMobile ? (
                    <FontAwesomeIcon icon={faCcPaypal} aria-label="PayPal" />
                  ) : method.type === "icon" ? (
                    <FontAwesomeIcon
                      icon={method.icon}
                      style={{ color: method.color }}
                    />
                  ) : (
                    <img
                      src={method.image}
                      alt={method.label}
                      className="payment-img"
                    />
                  )}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Quick Links - Policy & FAQ */}
        <div className="site-footer__col">
          <h3 className="site-footer__heading">POLICY & FAQ</h3>
          <ul className="site-footer__list" aria-label="Policy and FAQ links">
            {policy.map((item, index) => (
              <li key={index} className="site-footer__item">
                <a href={item.link} className="site-footer__link">
                  <FiChevronRight className="footer-link-icon" />
                  {item.linkname}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* About Us & Company Links */}
        <div className="site-footer__col">
          <h3 className="site-footer__heading">ABOUT US</h3>
          <ul className="site-footer__list">
            {about.map((item, index) => (
              <li key={index} className="site-footer__item">
                <a
                  href={item.Link}
                  className="site-footer__link"
                  target={item.external ? "_blank" : "_self"}
                  rel={item.external ? "noopener noreferrer" : ""}
                >
                  <FiChevronRight className="footer-link-icon" />
                  {item.Linkname}
                </a>
              </li>
            ))}
          </ul>
          <div className="footer-google-review">
            <a
              href="https://www.google.com/search?q=Elumia+Med+store&stick=H4sIAAAAAAAA_-NgU1I1qDBONU0zTUkzM0tMNEhNMbS0MqiwSEo2NkkzTUyxSLQwNDC3WMQq4JpTmpuZqOCbmqJQXJJflAoAxV6l8TwAAAA&hl=en-GB&mat=CX2wy0TXnoZ4ElYBTVDHnhh2kmfiYq12JOupeo6tJYor2RbhWg5vyGFViZ1HnoVo3a2_ZWLLb0oImFW18uSlF3EgUKl7uaX1gYWMoM17LZMW2cq_cQJ4qVpxomz3_rBeLQ&authuser=0"
              target="_blank"
              rel="noopener noreferrer"
              className="google-review-card"
            >
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/2/2f/Google_2015_logo.svg"
                alt="Google"
                className="google-review-logo"
              />
              <span className="google-review-text">Review us on Google</span>
            </a>
          </div>
        </div>

        {/* Location & Map Column */}
        <div className="site-footer__col footer-map">
          <h3 className="site-footer__heading">FIND US</h3>

          <div className="map-wrapper">
            {/* Clean Map Container */}
            <div className="map-container">
              <iframe
                className="footer-map-iframe"
                title="Elumia Med Store location map"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3607.321364140169!2d55.391407799999996!3d25.293404799999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5df66aa0ed19%3A0x8bc34f5ad8a81078!2sElumia%20Med%20store!5e0!3m2!1sen!2sin!4v1774695811358!5m2!1sen!2sin"
                width="600"
                height="420"
                // style="border:0;"
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>

              {/* Simple Location Badge */}
              {/* <div className="map-location-badge">
                <span className="map-pin">📍</span>
                <div className="location-text">
                  <strong>NVT Wireless Trading</strong>
                  <span>Al Qusais · Dubai, UAE</span>
                </div>
              </div> */}
            </div>

            {/* Simple address line - just the essential info */}
            {/* <div className="map-simple-address">
              <FiMapPin className="address-icon" />
              <span>
                NVT Wireless Trading, Al Qusais, Dubai, United Arab Emirates
              </span>
            </div> */}
          </div>
        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="footer-bottom">
        <p className="footer-bottom__text">
          © {new Date().getFullYear()} Elumia Med Store. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
}

const mapDispatchToProps = (dispatch) => {
  return {
    getcategoryRequest: (data) => dispatch(getcategoryRequest(data)),
  };
};

export default connect(null, mapDispatchToProps)(Footer);
